/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import Constants from '../../Config/Config';

class MetaData extends Component {
  render() {
    return (
      <div className="row">
        <div className="col-sm-6"><strong>Profile:</strong> {this.props.selectedFrame.get('name')}</div>

        {this.props.selectedFrame.getIn(['dimensions', 'height']) !== undefined && <div className="col-sm-6"><strong>Height:</strong> {this.props.selectedFrame.getIn(['dimensions', 'height'])}cm</div>}

        {this.props.selectedFrame.getIn(['dimensions', 'width']) !== undefined && <div className="col-sm-6"><strong>Width:</strong> {this.props.selectedFrame.getIn(['dimensions', 'width'])}cm</div>}

        {this.props.selectedFrame.get('frame_color') !== '' && <div className="col-sm-6"><strong>Color:</strong> {this.props.selectedFrame.get('frame_color')}</div>}

        {this.props.selectedFrame.get('frame_material') !== '' && <div className="col-sm-6"><strong>Material:</strong> {this.props.selectedFrame.get('frame_material')}</div>}

        {this.props.selectedFrame.get('frame_finish') !== '' && <div className="col-sm-6"><strong>Finish:</strong> {this.props.selectedFrame.get('frame_finish')}</div>}

        {this.props.selectedFrame.get('frame_style') !== '' && <div className="col-sm-6"><strong>Style:</strong> {this.props.selectedFrame.get('frame_style')}</div>}

        <div className="col-sm-6"><strong>Price:</strong> {Constants.Currency + this.props.canvasFrameTotal}</div>
      </div>
    );
  }
}
export default MetaData;